/**
 * Logger utilitário que remove logs em produção
 * Reduz overhead de logging em produção
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  warn: (...args: any[]) => {
    // Warnings sempre são mostrados, mesmo em produção
    console.warn(...args);
  },
  
  error: (...args: any[]) => {
    // Errors sempre são mostrados, mesmo em produção
    console.error(...args);
  },
};
